import { render, staticRenderFns } from "./mt-switch.vue?vue&type=template&id=76019029&scoped=true&"
import script from "./mt-switch.vue?vue&type=script&setup=true&lang=js&"
export * from "./mt-switch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./mt-switch.vue?vue&type=style&index=0&id=76019029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76019029",
  null
  
)

export default component.exports